import React from "react";
import Icon from "../../Icon/Icon";
import Typography from "../../Typography/Typography";
import Button from "../../Buttons/Button/Button";

interface Props {
    children: React.ReactNode;
    onClose?: () => void;
}

const FlyoutHeader = ({ children, onClose }: Props) => (
    <div data-test="flyout-header" className="w-full flex flex-row items-center justify-between">
        <Typography as="h2" variant="subHeading" className="p-2 grow">
            {children}
        </Typography>
        <Button onClick={onClose} variant="none" className="px-2 py-1">
            <Icon icon="cross" />
        </Button>
    </div>
);

export default FlyoutHeader;
